function formatDate(date) {
  const addZero = (i) => i < 10 ? '0' + i : i
  let hour = addZero(date.getHours())
  let mins = addZero(date.getMinutes())
  let secs = addZero(date.getSeconds())
  let y = date.getFullYear()
  let m = addZero(date.getMonth()+1)
  let d = addZero(date.getDate())
  return y + '-' + m + '-' + d + ' ' + hour + ':' + mins + ':' + secs
}
function fill(symb=' ', n=1) {
  if(n<1)
    return ''
  return symb.repeat(n)
}

export default class Message {
  constructor(mess={}) {
    this.app  = mess.app  || ''
    this.name = mess.name || 'fatal'
    this.txt  = mess.txt  || ''
    this.cl   = mess.cl   || ''
    this.func = mess.func || ''
    this.obj  = mess.obj  || null
    if(mess.obj &&  mess.obj.str)
        this.obj = mess.obj.str()
    if(mess.obj && !mess.obj.str)
        this.obj = mess.obj.toString()
    this.date = formatDate(new Date())
    this.isMessage = true
  }
  str(sp=' ', br='\n') {
    let res = `>>>>> [${this.date}] ${this.name.toUpperCase()}`
    res+= fill(sp, 7-this.name.length)
    if(this.app)
      res+= ` | ${this.app}`
    if(this.cl)
      res+= ` | ${this.cl}`
    if(this.func)
      res+= ` | ${this.func}`
    if(this.txt)
      res+= br + fill(sp, 4) +  `> ${this.txt}`
    if(this.obj)
      res+= br + fill(sp, 3) + `>> DETAILS:` + br + this.obj + br +  `-----`
    return res
  }
  strCompact() {
    return `[${this.date}] ${this.txt}`
  }
  htm() {
    return this.str('&nbsp;', '<br>')
  }
  json() {
    return {app: this.app, name: this.name, txt: this.txt, cl: this.cl, func: this.func, obj: this.obj, isMessage: true}
  }
}



// WEBPACK FOOTER //
// ./src/cs/Message.js